import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { MyButton } from "../../common/components";
import ReferralCreateDialog from "./ReferralCreateDialog";

const ReferralCreateButton = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <MyButton
        color="primary"
        variant="contained"
        startIcon={<AddIcon />}
        fullWidth={false}
        sx={{ height: "40px" }}
        onClick={handleOpen}
      >
        Add Referral/Order
      </MyButton>

      <ReferralCreateDialog open={open} onClose={handleClose} {...props} />
    </>
  );
};

export default ReferralCreateButton;
